import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Container, Navbar } from "react-bootstrap";


import NavbarNav from "./NavbarNav/NavbarNav";
import NavbarToggle from "./NavbarToggle";
import "./MainNavbar.css";

const MainNavbar = ({ layout, stickyTop }) => {
  const classes = classNames(
    "main-navbar",
    "smartfarm-global-header",
    "bg-white",
    stickyTop && "sticky-top"
  );

  return (
    <div className={classes}>
     <div className="p-0"> 
        <Navbar type="light" className="align-items-stretch flex-md-nowrap p-0">
          <div className="smartfarm-header-actions d-flex justify-content-end w-100">
            <NavbarNav />
            <NavbarToggle />
          </div>
        </Navbar>
      </div>
    </div>
  );
};

MainNavbar.propTypes = {
  /**
   * The layout type where the MainNavbar is used.
   */
  layout: PropTypes.string,
  /**
   * Whether the main navbar is sticky to the top, or not.
   */
  stickyTop: PropTypes.bool
};

MainNavbar.defaultProps = {
  stickyTop: true
};

export default MainNavbar;
